/* @flow */
import { GdprStorage } from "../uidispatcherapi/GdprStorage";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import CustomerStore from "./CustomerStore";
import { Store } from "../utils/Store";
import { isFsdShop } from "../utils/ShopFlavor";

import { AuthorizationData } from "../datatypes/Authorization";

function extractStoreIdsFromAuthData(authData: AuthorizationData | undefined | null): Set<string> | undefined | null {
    return authData?.uStores
        ? new Set(
              authData.uStores
                  .split(",")
                  .map((entStore) => entStore.replace(/\D+/g, ""))
                  .map((num) => ("0000" + num).slice(-5))
          )
        : null;
}

class AddressSelectionRedirectStore extends Store {
    authData: Set<string> | undefined | null;
    hasRedirected: boolean = Boolean(GdprStorage.sessionStorage.get("fsdAddressWasSelected").actualResult);

    setStateOnRedirect() {
        this.hasRedirected = true;
        GdprStorage.sessionStorage.put("fsdAddressWasSelected", "true", GdprStorage.FUNCTIONAL);
    }

    hasRedirectedForFsdCustomer(): boolean {
        return this.hasRedirected;
    }

    // If we can be sure that no redirect is necessary, set the state as well to prevent accidental redirects.
    fsdCustomerHasSuitableAddressSelected() {
        if (SessionStore.getSelectedDeliveryAddressHash()) {
            this.setStateOnRedirect();
            return true;
        }
        const customer = CustomerStore.getCustomer();
        if (customer && !customer.validForFsd) {
            this.setStateOnRedirect();
            return true;
        }
        if (customer && customer.validForFsd && !SessionStore.getSelectedDeliveryAddressHash()) {
            return false;
        }
        if (!isFsdShop()) {
            return false;
        }
        if (!this.authData) {
            this.authData = extractStoreIdsFromAuthData(SessionStore.getAuthorizationData());
        }
        const store = SessionStore.getCustomerStore();
        if (store && this.authData) {
            return this.authData.has(store);
        }
        return true;
    }
}
export default new AddressSelectionRedirectStore();
